import React from "react";
import Cohere from "cohere-js";
import { BrowserRouter } from "react-router-dom";
import * as Sentry from "@sentry/react";

import LabLocalizationProvider from "@mui/lab/LocalizationProvider";
import LabDateAdapter from "@mui/lab/AdapterMoment";
import { LocalizationProvider as DatePickerLocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment as DatePickerMomentAdapter } from "@mui/x-date-pickers/AdapterMoment";

import SnackbarProvider from "./globals/hooks/useSnackbar/Provider";
import Router from "./Router";
import "./App.css";

Sentry.init({ dsn: import.meta.env.REACT_APP_SENTRY_PUBLIC_DSN });

Cohere.init(import.meta.env.REACT_APP_COHERE_API_KEY, {
  disableRecording: true,
});

function App() {
  return (
    <LabLocalizationProvider dateAdapter={LabDateAdapter}>
      <DatePickerLocalizationProvider dateAdapter={DatePickerMomentAdapter}>
        <SnackbarProvider>
          <BrowserRouter>
            <Router />
          </BrowserRouter>
        </SnackbarProvider>
      </DatePickerLocalizationProvider>
    </LabLocalizationProvider>
  );
}

export default App;
